import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AccountModificationQueryResult,
  AccountData,
  AutoPaymentMode,
  AutoPaymentModeMap,
  AccountModificationSnapshot,
} from '../account.model';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { QueryParams, FeeType, QueryParamsService } from 'common';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { readWrite } from '../../user/user-permission/user-permission.data';
import { routerTransition } from '../../shared/animations/router.animations';
import { UserData } from '../../user/user.model';
import * as _ from 'lodash';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-account-modification-list',
    templateUrl: './account-modification-list.component.html',
    styleUrls: ['./account-modification-list.component.scss'],
    animations: routerTransition,
    standalone: false
})
export class AccountModificationListComponent implements OnInit {

  canUpdateModification = false;
  queryParams: any;
  data: AccountModificationListComponentData;
  displayColumns: string[] = [
    'placeholder',
    'startDate',
    'endDate',
    'active',
    'activatedOn',
    'autoPaymentMode',
    'interestRate',
    'accureInterest',
    'reAmortize',
    'paymentAmount',
    'repaymentTerm',
    'drawFee',
    'updatedOn',
    'notes'
  ];

  get FeeType() { return FeeType; }

  getAutopaymentMode(mode: AutoPaymentMode): string {
    return AutoPaymentModeMap.get(mode);
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userPermissionService: UserPermissionService,
    private queryParamsService: QueryParamsService) { }

  ngOnInit() {
  this.route.data.pipe(untilDestroyed(this))
      .subscribe((it: AccountModificationListComponentData) => {

        this.data = it;
        const modification = this.data.account ? this.data.account.modification as AccountModificationSnapshot : null;

        if (this.data.accountModificationQueryResult.totalCount > 1) {
          if (modification)
            modification.paymentAmount = this.data.accountModificationQueryResult.values[0].paymentAmount;
          this.data.accountModificationQueryResult.values.unshift({ label: 'Modification log', isGroup: true });
          _.remove(this.data.accountModificationQueryResult.values, modification);
        }

        if (this.data.accountModificationQueryResult.totalCount && modification) {
          if (this.data.accountModificationQueryResult.totalCount > 1)
            this.data.accountModificationQueryResult.values.unshift(modification);
          this.data.accountModificationQueryResult.values.unshift({ label: 'Modification', isGroup: true });
        }
      });

  this.route.queryParams.pipe(untilDestroyed(this))
      .subscribe(it => { this.queryParams = this.queryParamsService.init(it); });

    this.userPermissionService.granted([readWrite('servicing-account-modification')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.canUpdateModification = res);

    this.paginator.pageSize = this.queryParams.limit;
    this.paginator.pageIndex = this.queryParams.skip / this.queryParams.limit;
  }

  isGroup(index, item): boolean {
    return item && item.isGroup;
  }

  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  setPage(event: PageEvent) {
    const query: QueryParams = {};
    query.limit = this.paginator.pageSize;
    query.skip = this.paginator.pageIndex * this.paginator.pageSize;

    this.router.navigate([`account/${this.data.account.id}/modification`], { replaceUrl: true, queryParams: query });
  }
}

export interface AccountModificationListComponentData {
  account?: AccountData;
  accountModificationQueryResult: AccountModificationQueryResult;
  userCurrent?: UserData;
}
